import http from "@/http/radar-grid/axios";
const resource = "/radargrid/radar_bases";

export default {
  // 観測拠点グループの取得
  fetchRadarBaseGroupsByEnterpriseId(aiseaEnterpriseId) {
    return http.get(
      `${resource}/aisea_enterprise_radar_base_groups/${aiseaEnterpriseId}`
    );
  },

  // 観測拠点グループの過去履歴表示エリアの取得
  fetchHistoryDisplayAreas(payload) {
    return http.get(`${resource}/history_display_areas`, {
      params: payload,
    });
  },
};
